<template>
	<b-overlay :show="isLoading">
		<b-row class="gap-y-1">
			<b-col cols="12" md="4">
				<h2 class="text-secondary font-weight-bolder">POR COLORES</h2>
			</b-col>
			<b-col cols="12" md="8" class="d-flex justify-content-end align-items-center gap-x-2">
				<b-input-group size="sm" prepend="Genero" style="max-width: 15rem">
					<b-form-select :options="genderOpts" v-model="gender" @change="changePagination(1, 'select')" />
				</b-input-group>
				<b-button-group size="sm">
					<b-button
						class="btn-icon"
						variant="outline-secondary"
						:disabled="pagination.page <= 1"
						@click="changePagination(-1, 'paginator')"
					>
						<feather-icon icon="ChevronLeftIcon" />
					</b-button>
					<b-button
						class="btn-icon"
						variant="outline-secondary"
						:disabled="pagination.page >= pagination.maxPage"
						@click="changePagination(1, 'paginator')"
					>
						<feather-icon icon="ChevronRightIcon" />
					</b-button>
				</b-button-group>
			</b-col>
		</b-row>
		<hr />
		<VueApexCharts type="bar" height="300" :options="chartOpts" :series="chartData" />
	</b-overlay>
</template>

<script>
import VueApexCharts from "vue-apexcharts"

export default {
	components: { VueApexCharts },
	props: { year: Object, info: Object, count: Number },
	data: () => ({
		isLoading: true,
		genderOpts: [
			{ value: 1, text: "Machos" },
			{ value: 2, text: "Hembras" },
			// { value: null, text: "Todos" },
		],
		gender: 1,
		chartData: [
			{
				name: "Color",
				data: new Array(6).fill(3),
			},
		],
		chartOpts: {
			labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio"],
			colors: ["#2C3E50"],
			xaxis: { labels: { trim: true, rotate: 0, hideOverlappingLabels: false } },
		},
		pagination: {
			page: 1,
			maxPage: 2,
		},
	}),
	methods: {
		async getData() {
			if (this.info) {
				this.isLoading = false
			}
			this.pagination.maxPage = this.info.last_page
			this.chartData = [
				{
					name: "Color",
					data: this.info.data.map((d) => d.counter),
				},
			]
			this.chartOpts = {
				labels: this.info.data.map((d) => d.color),
				colors: ["#2C3E50"],
				xaxis: { labels: { trim: true, rotate: 0, hideOverlappingLabels: false } },
				fill: {
					type: "gradient",
					gradient: {
						shade: "light",
						type: "horizontal",
						shadeIntensity: 0.25,
						gradientToColors: undefined,
						inverseColors: true,
						opacityFrom: 0.85,
						opacityTo: 0.85,
						stops: [50, 0, 100],
					},
				},
			}
		},
		changePagination(diff, origin) {
			if (origin === "select") {
				this.pagination.page = diff
			} else {
				this.pagination.page += diff
			}
			this.isLoading = true
			this.$emit("refresh", { page: this.pagination.page, gender: this.gender })
		},
	},
	watch: {
		info() {
			this.getData()
		},
		count() {
			this.isLoading = true
		},
	},
}
</script>
